import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4badb528"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal__inner__body"
}
const _hoisted_2 = { class: "contact__wrapper" }
const _hoisted_3 = { class: "contact_form" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "" }, "Phone Number", -1))
const _hoisted_5 = { class: "contact_input" }
const _hoisted_6 = { class: "tw-min-w-[300px] rmd:tw-min-w-[360px] !tw-w-full" }
const _hoisted_7 = { class: "contact_input_code" }
const _hoisted_8 = {
  key: 1,
  class: "modal__carousel__content md:!tw-max-w-[unset]"
}
const _hoisted_9 = { class: "onboarding-steps-content__upload md:!tw-gap-[0rem] md:!tw-mb-0 md:!tw-overflow-auto" }
const _hoisted_10 = { class: "uploade-wrapper md:!tw-my-4 md:!tw-mx-auto md:!tw-w-full md:!tw-h-auto md:!tw-flex md:!tw-flex-col md:!tw-gap-4 md:!tw-items-center md:!tw-mb-0" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "next_step_btns tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_flag = _resolveComponent("flag")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_Text = _resolveComponent("Text")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_stepper = _resolveComponent("v-stepper")!
  const _component_commonDialog = _resolveComponent("commonDialog")!
  const _component_PropertyOwnerWorkStationModal = _resolveComponent("PropertyOwnerWorkStationModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isShowPropertyOwnerOnboarding)
      ? (_openBlock(), _createBlock(_component_commonDialog, {
          key: 0,
          HeaderTittle: $setup.currentSelectedTab?.header,
          title: $setup.currentSelectedTab?.title,
          description: $setup.currentSelectedTab?.description,
          onClickBackButton: $setup.onClickBackButton,
          className: ['onboarding__dialog']
        }, {
          body: _withCtx(() => [
            ($setup.currentSelectedTab?.id == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_v_form, {
                    onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                    rules: $setup.validation,
                    ref: "formRef"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                          _hoisted_4,
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_v_autocomplete, {
                              modelValue: $setup.countryCode,
                              "onUpdate:modelValue": [
                                _cache[0] || (_cache[0] = ($event: any) => (($setup.countryCode) = $event)),
                                $setup.handleCountryCode
                              ],
                              items: $setup.countryinfo,
                              "item-title": "name",
                              "item-value": "dial_code",
                              class: "flag-selector input_field",
                              rounded: "",
                              outlined: "false"
                            }, {
                              chip: _withCtx(({ props, item }) => [
                                _createVNode(_component_flag, _mergeProps(props, {
                                  style: {"font-size":"14px","width":"100%"},
                                  iso: item.raw.code
                                }), null, 16, ["iso"])
                              ]),
                              item: _withCtx(({ props, item }) => [
                                _createElementVNode("div", _hoisted_6, [
                                  _createVNode(_component_v_list_item, _mergeProps(props, {
                                    title: item.raw.name,
                                    class: "country__selector tw-w-full"
                                  }), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_flag, _mergeProps(props, {
                                        style: {"font-size":"16px"},
                                        iso: item.raw.code
                                      }), null, 16, ["iso"])
                                    ]),
                                    _: 2
                                  }, 1040, ["title"])
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "items", "onUpdate:modelValue"]),
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("p", null, _toDisplayString($setup.countryCode), 1)
                            ]),
                            _createVNode(_component_v_text_field, {
                              type: "text",
                              density: "compact",
                              placeholder: "Phone Number",
                              modelValue: $setup.userPhone,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.userPhone) = $event)),
                              rules: $setup.validation.phone,
                              rounded: "",
                              class: "c-input"
                            }, null, 8, ["modelValue", "rules"])
                          ])
                        ]),
                        _createVNode(_component_v_btn, {
                          class: "button button-orange w-full",
                          disabled: !$setup.isPhoneValid,
                          loading: $setup.isPhoneNumberSend,
                          onClick: $setup.onClickCompleteOnboarding
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" complete onboarding ")
                          ]),
                          _: 1
                        }, 8, ["disabled", "loading", "onClick"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["rules"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_v_file_input, {
                        class: _normalizeClass(["upload_file md:!tw-w-[150px] md:!tw-h-[150px] md:!tw-m-0 md:!tw-overflow-hidden", { 'added-img': $setup.imageUrl }]),
                        "append-inner-icon": "mdi-image-plus",
                        accept: "image/png, image/jpeg",
                        variant: "solo-filled",
                        onChange: $setup.onFileChange,
                        "onClick:clear": $setup.clearImageUrl
                      }, null, 8, ["class", "onChange", "onClick:clear"]),
                      _createVNode(_component_v_img, {
                        class: "uploaded-img md:!tw-w-[150px] md:!tw-h-[150px] md:!tw-left-[unset]",
                        width: 200,
                        "aspect-ratio": "16/9",
                        cover: "",
                        src: $setup.imageUrl
                      }, null, 8, ["src"]),
                      _createVNode(_component_Text, {
                        variant: "p",
                        textAlign: "center",
                        textColor: "rgba(255, 0, 0,0.5)"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.fileUploadErrorMsg), 1)
                        ]),
                        _: 1
                      }),
                      _hoisted_11,
                      _createVNode(_component_Text, {
                        variant: "span",
                        textAlign: "center",
                        textColor: "rgba(12, 15, 74, 0.5)"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Accepted file formats: PNG, JPEG")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_v_btn, {
                        class: "button button-orange w-full traking",
                        disabled: $setup.isContinueDisabled,
                        loading: $setup.isImageUpload,
                        onClick: $setup.onClickSaveImage
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" continue ")
                        ]),
                        _: 1
                      }, 8, ["disabled", "loading", "onClick"]),
                      _createVNode(_component_Text, {
                        variant: "p",
                        textWeight: "500",
                        textColor: "rgba(12, 15, 74, 0.5)"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("No Image? "),
                          _createVNode(_component_Text, {
                            onClick: $setup.onClickSkipForNow,
                            class: "tw-cursor-pointer",
                            variant: "p",
                            textWeight: "500",
                            textColor: "#FFA500"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Skip for now "),
                              _createVNode(_component_v_icon, {
                                icon: "mdi-chevron-right",
                                color: "#FFA500"
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_v_stepper, {
              class: "onboard-stepper",
              modelValue: $setup.currentSelectedTab.id,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.currentSelectedTab.id) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_stepper_header, { class: "onboard-stepper__header" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.modelDetails, (step) => {
                      return (_openBlock(), _createBlock(_component_v_stepper_item, {
                        class: _normalizeClass(["onboard-stepper__item", { done: $setup.currentSelectedTab.id > step?.id }]),
                        key: step?.id,
                        title: step?.tab,
                        value: step?.id
                      }, null, 8, ["class", "title", "value"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["HeaderTittle", "title", "description", "onClickBackButton"]))
      : _createCommentVNode("", true),
    ($setup.isShowPropertyOwnerWorkStationModal)
      ? (_openBlock(), _createBlock(_component_PropertyOwnerWorkStationModal, {
          key: 1,
          onOnClickCloseTab: $setup.onClickClosePOWorkstationModal
        }, null, 8, ["onOnClickCloseTab"]))
      : _createCommentVNode("", true)
  ], 64))
}